import React from 'react'
import './Footer.css'

function Footer() {
    return (
        <footer>
            <div className="container">
                <div className="footer-content">
                    <div className="footer-links">
                        <a href="/about">درباره ما</a>
                        <a href="/contact">تماس با ما</a>
                        <a href="/blog">مقالات</a>
                    </div>
                    <div className="footer-copyright">
                        © {new Date().getFullYear()} چکیده سرا. تمامی حقوق محفوظ است.
                    </div>
                    
                    {/* ========== نماد اعتماد اینماد ========== */}
                    <div className="enamad-logo">
                        <a referrerpolicy='origin' target='_blank' href='https://trustseal.enamad.ir/?id=729145&Code=xXID0C578LTcR6LyRIMo1rSichKw1CuE'>
                            <img 
                                referrerpolicy='origin' 
                                src='https://trustseal.enamad.ir/logo.aspx?id=729145&Code=xXID0C578LTcR6LyRIMo1rSichKw1CuE' 
                                alt='نماد اعتماد الکترونیکی' 
                                style={{ cursor: 'pointer', maxWidth: '100px', height: 'auto' }} 
                                code='xXID0C578LTcR6LyRIMo1rSichKw1CuE'
                            />
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer